(function(){
  'use strict';

  var SELECTOR = '#CurveCartDrawer';
  var refreshPromise = null;

  function drawer(){ return document.querySelector(SELECTOR); }

  function setBusy(isBusy){
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-loading', !!isBusy);
  }

  function openDrawer(){
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden','false');
    document.body.classList.add('curve-cart-open');
    var panel = d.querySelector('.ccart__panel');
    if (panel) setTimeout(function(){ try { panel.focus(); } catch(e){} }, 20);
  }

  function closeDrawer(){
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden','true');
    document.body.classList.remove('curve-cart-open');
  }

  function sectionInner(html, selector){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function updateCartIcon(html){
    if (!html) return;
    var current = document.getElementById('cart-icon-bubble');
    var next = sectionInner(html, '#shopify-section-cart-icon-bubble');
    if (!current || !next) return;
    current.innerHTML = next.innerHTML;
  }

  function refreshDrawer(options){
    options = options || {};
    if (refreshPromise) return refreshPromise.then(function(){ if(options.open) openDrawer(); });
    setBusy(true);
    refreshPromise = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer,cart-icon-bubble', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function(r){ if(!r.ok) throw new Error('Could not refresh cart'); return r.json(); })
    .then(function(sections){
      var shouldOpenAfterRefresh = !!options.open || (drawer() && drawer().classList.contains('is-open'));
      if (sections['cart-drawer']) {
        var nextDrawer = sectionInner(sections['cart-drawer'], SELECTOR);
        var currentDrawer = drawer();
        if (nextDrawer && currentDrawer) currentDrawer.outerHTML = nextDrawer.outerHTML;
      }
      updateCartIcon(sections['cart-icon-bubble']);
      bindDrawerEvents();
      if (shouldOpenAfterRefresh) openDrawer();
    })
    .catch(function(err){ console.warn('[Curve cart drawer]', err); if (options.open) openDrawer(); })
    .finally(function(){ setBusy(false); refreshPromise = null; });
    return refreshPromise;
  }

  function addForm(form){
    var submitter = form.querySelector('[type="submit"], button:not([type]), button[type="button"]');
    if (submitter) submitter.setAttribute('aria-busy', 'true');
    var body = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function(r){
      if (!r.ok) return r.json().then(function(j){ throw j; });
      return r.json();
    })
    .then(function(){ return refreshDrawer({open:true}); })
    .catch(function(err){
      console.warn('[Curve cart drawer] add error', err);
      var message = (err && (err.description || err.message)) ? (err.description || err.message) : 'Could not add this item to cart.';
      alert(message);
    })
    .finally(function(){ if (submitter) submitter.removeAttribute('aria-busy'); });
  }

  function addVariant(variantId, qty, properties){
    if (!variantId) return Promise.resolve();
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1, properties: properties || {} })
    })
    .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw j; }); return r.json(); })
    .then(function(){ return refreshDrawer({open:true}); })
    .catch(function(err){
      console.warn('[Curve cart drawer] add variant error', err);
      alert((err && (err.description || err.message)) ? (err.description || err.message) : 'Could not add this item.');
    });
  }

  function changeLine(line, quantity){
    setBusy(true);
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
    })
    .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw j; }); return r.json(); })
    .then(function(){ return refreshDrawer({open:true}); })
    .catch(function(err){ console.warn('[Curve cart drawer] quantity error', err); })
    .finally(function(){ setBusy(false); });
  }

  function bindDrawerEvents(){
    var d = drawer();
    if (!d || d.dataset.bound === 'true') return;
    d.dataset.bound = 'true';

    d.addEventListener('click', function(e){
      if (e.target.closest('[data-curve-cart-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var remove = e.target.closest('[data-curve-remove]');
      if (remove) {
        e.preventDefault();
        var item = remove.closest('[data-line]');
        if (item) changeLine(item.getAttribute('data-line'), 0);
        return;
      }
      var qtyBtn = e.target.closest('[data-curve-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var row = qtyBtn.closest('[data-line]');
        var input = row && row.querySelector('[data-curve-qty-input]');
        if (!row || !input) return;
        var next = (parseInt(input.value,10) || 0) + (parseInt(qtyBtn.getAttribute('data-curve-qty-change'),10) || 0);
        changeLine(row.getAttribute('data-line'), next);
        return;
      }
      var bumpBtn = e.target.closest('[data-curve-bump-add]');
      if (bumpBtn) {
        e.preventDefault();
        var bump = bumpBtn.closest('[data-curve-bump]');
        var select = bump && bump.querySelector('[data-curve-bump-variant]');
        if (select && select.value) {
          bumpBtn.disabled = true;
          addVariant(select.value, 1, {'_Order bump':'Complete your routine'}).finally(function(){ bumpBtn.disabled = false; });
        }
      }
    });

    d.addEventListener('change', function(e){
      if (e.target.matches('[data-curve-qty-input]')) {
        var row = e.target.closest('[data-line]');
        if (row) changeLine(row.getAttribute('data-line'), parseInt(e.target.value,10) || 0);
      }
    });
  }

  function bindGlobalEvents(){
    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;
      if (form.closest('[data-curve-ignore-ajax]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addForm(form);
    }, true);

    document.addEventListener('click', function(e){
      var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, [data-curve-cart-open]');
      if (cartLink && drawer()) {
        e.preventDefault();
        refreshDrawer({open:true});
      }
    }, true);

    document.addEventListener('cart:open', function(){ openDrawer(); });
    document.addEventListener('cart:refresh', function(){ refreshDrawer({open:false}); });
    document.addEventListener('cart:updated', function(){ refreshDrawer({open:false}); });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeDrawer(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ bindDrawerEvents(); bindGlobalEvents(); });
  } else {
    bindDrawerEvents(); bindGlobalEvents();
  }

  window.CurveCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer,
    addVariant: addVariant
  };
})();
